var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("base-dialog", {
        attrs: {
          okFn: function() {
            _vm.registerUser(this$1.USER_TYPES.PROFESSIONAL)
          },
          cancelFn: function() {
            _vm.dialogOpenlegalLaywerVisible = false
          },
          content: _vm.$t("login.dialog-lawyer")
        },
        model: {
          value: _vm.dialogOpenlegalLaywerVisible,
          callback: function($$v) {
            _vm.dialogOpenlegalLaywerVisible = $$v
          },
          expression: "dialogOpenlegalLaywerVisible"
        }
      }),
      _vm._v(" "),
      _c("b-col", { staticClass: "card-ctn", attrs: { cols: "12", xl: "6" } }, [
        _c(
          "div",
          {
            staticClass: "card-login",
            style: { "min-height": _vm.cardHeight }
          },
          [
            _c(
              "div",
              { staticClass: "my-auto" },
              [
                _c("login-form", {
                  attrs: { title: _vm.$t("login.already-signed-in") }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("b-col", { staticClass: "card-ctn", attrs: { cols: "12", xl: "6" } }, [
        _c(
          "div",
          {
            staticClass: "card-login",
            style: { "min-height": _vm.cardHeight }
          },
          [
            _c(
              "div",
              { staticClass: "my-auto" },
              [
                _c("div", [
                  _c("h3", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("login.new-user")) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.inOpensalud360()
                    ? _c("p", { staticStyle: { "white-space": "initial" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("login.register-now")) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.showProfessionalButton
                  ? _c(
                      "base-button",
                      {
                        staticClass: "mt-4 d-block w-100 btn-mobile",
                        attrs: { variant: "primary" },
                        on: { click: _vm.registerProfessional }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.inOpenlegal()
                                ? _vm.$t("login.iam-lawyer")
                                : _vm.$t("login.iam-professional")
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "w-100 btn-mobile mt-4 d-block",
                    attrs: { variant: "primary" },
                    on: { click: _vm.registerPatient }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.patientBtnText) + "\n\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.showCenterButton
                  ? _c(
                      "base-button",
                      {
                        staticClass: "w-100 btn-mobile mt-4 d-block",
                        attrs: { variant: "primary" },
                        on: { click: _vm.registerCenter }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.inOpenlegal()
                                ? _vm.$t("login.iam-lawfirm")
                                : _vm.$t("login.iam-centre")
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d75076c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d75076c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/LoginOrRegister.vue
// module id = 2935
// module chunks = 78 96